import { useState } from "react";
import { useTranslation } from "react-i18next";

import ReviewCard from "../../components/ReviewCard/ReviewCard";

import "./Reviews.css";

const Reviews = ({ innerRef }) => {
	const { t } = useTranslation();

	// TODO: IMPROVE THIS TO BE AUTOMATICALLY
	const reviews = t("reviews.items", { returnObjects: true });
	const reviews2 = t("reviews.items2", { returnObjects: true });

	const [actualReviewsSection, setActualReviewsSection] = useState(0);
	const [actualReviews, setActualReviews] = useState(reviews);

	const handleSectionChange = (e, section) => {
		e.preventDefault();
		setActualReviewsSection(section);

		if (section === 0) {
			setActualReviews(reviews);
		} else if (section === 1) {
			setActualReviews(reviews2);
		}
	};

	return (
		<div id="home-reviews" ref={innerRef} className="reviews-bg">
			<h2 className="reviews-title">{t("reviews.title")}</h2>

			<div className="reviews-content">
				{actualReviews.map((item, index) => (
					<ReviewCard
						key={"Reviews" + index}
						data={{
							id: index,
							name: item["name"],
							image: item["image"],
							alt: item["alt"],
							stars: item["stars"],
							description: item["description"],
						}}
					/>
				))}
			</div>
			<div className="reviews-content-sections">
				<div
					className="reviews-content-section"
					onClick={(e) => handleSectionChange(e, 0)}
				>
					<img
						alt={"section-0"}
						src={`${
							actualReviewsSection === 0
								? require("../../assets/icons/reviews-selected.webp")
								: require("../../assets/icons/reviews-non-selected.webp")
						}`}
						className={`reviews-content-section-icon ${
							actualReviewsSection === 0
								? "reviews-content-section-icon-selected"
								: "reviews-content-section-icon-non-selected"
						}`}
					/>
				</div>
				<div
					className="reviews-content-section"
					onClick={(e) => handleSectionChange(e, 1)}
				>
					<img
						alt={"section-1"}
						src={`${
							actualReviewsSection === 1
								? require("../../assets/icons/reviews-selected.webp")
								: require("../../assets/icons/reviews-non-selected.webp")
						}`}
						className={`reviews-content-section-icon ${
							actualReviewsSection === 1
								? "reviews-content-section-icon-selected"
								: "reviews-content-section-icon-non-selected"
						}`}
					/>
				</div>
			</div>
		</div>
	);
};

export default Reviews;
